import { render, staticRenderFns } from "./TimeLimitKitchenBanner.vue?vue&type=template&id=0b5f5cd6&"
import script from "./TimeLimitKitchenBanner.vue?vue&type=script&lang=js&"
export * from "./TimeLimitKitchenBanner.vue?vue&type=script&lang=js&"
import style0 from "./TimeLimitKitchenBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports